<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button type="primary" size="small" @click="openAdd()" icon="el-icon-edit">批量充值</el-button>
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">下单时间{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" class="width-250" v-model="search.bat_code">
                        <span slot="prepend">批次号{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" class="width-250" v-model="search.goods_cname">
                        <span slot="prepend">商品名称{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw show-scroll" height="100%">
                    <el-table-column fixed :label="listHeader.bat_code" width="160px">
                        <el-table-column label-class-name="f-red pd-top0" width="160px">
                            <div class="f-red" slot-scope="scope" slot="header">合计</div>
                            <div class="f-brown" slot-scope="scope">{{scope.row.bat_code}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" min-width="170px"></el-table-column>
                    <el-table-column prop="goods_cname" :label="listHeader.goods_cname" width="150px"></el-table-column>
                    <el-table-column :label="listHeader.goods_amt" width="90px">
                        <div slot-scope="scope">{{scope.row.goods_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.guest_cost_amt" width="110px">
                        <div slot-scope="scope">{{scope.row.guest_cost_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.order_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="90px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.order_qty * 1}}</div>
                            <div slot-scope="scope">{{scope.row.order_qty}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.over_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="90px">
                            <div class="f-red" slot-scope="scope" slot="header">{{totalData.sum.over_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.over_qty}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.ok_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="90px">
                            <div class="f-green" slot-scope="scope" slot="header">{{totalData.sum.ok_qty * 1}}</div>
                            <div class="f-bd f-green" slot-scope="scope">{{scope.row.ok_qty}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.err_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="90px">
                            <div class="f-red" slot-scope="scope" slot="header">{{totalData.sum.err_qty * 1}}</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.err_qty}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.tot_goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                            <div class="f-red" slot-scope="scope" slot="header">{{totalData.sum.tot_goods_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.tot_goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.tot_guest_cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                            <div class="f-red" slot-scope="scope" slot="header">{{totalData.sum.tot_guest_cost_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.tot_guest_cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.ok_goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="100px">
                            <div class="f-red" slot-scope="scope" slot="header">{{totalData.sum.ok_goods_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.ok_goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.ok_guest_cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="130px">
                            <div class="f-red" slot-scope="scope" slot="header">{{totalData.sum.ok_guest_cost_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.ok_guest_cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
import myPager from '../../../components/myPager'
import myDatePicker from "../../../components/myDatePicker";
import excel from '../../../utils/excel'
export default {
    name:'charge-mobilebat',
    components:{
        myPager,
        myDatePicker
    },
    data: function(){
        const listHeader = {
            bat_code: '批次号',
            goods_cname: '商品',
            goods_amt: '面值',
            guest_cost_amt: '结算单价',
            order_qty: '单量',
            tot_goods_amt: '总面值',
            tot_guest_cost_amt: '结算价',
            over_qty: '已处理单量',
            ok_qty: '成功单量',
            err_qty: '失败单量',
            ok_goods_amt: '成功面值',
            ok_guest_cost_amt: '成功结算价',
            add_time: '下单时间'
        }
        return{
            relist: false,
            show_subview: false,
            search:{
                search_url: 'order-c-bat/list-by-guest',
                datearea_id:1,//如果大于0 mounted 要删除date_fr date_to
                date_fr: '',
                date_to: '',
                page: 1,
                pageSize: 0,
                limit:'20',
                bat_code: "",
                goods_cname:''
            },
            listHeader,
            listData:[],
            totalData: {
                total: 0,//总行数
                sum:{}
            }
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
    },
    mounted:function(){
        this.$base.setMenuOpens();
        this.$base.listPageInit(this,()=>{
            this.list();
        });
    },
    methods: {
        onDateChange: function(data){
            this.search.date_fr = data[0];
            this.search.date_to = data[1];
        },
        onPagerChange: function () {
            this.list(true);
        },
        onLimitChange: function (limit) {
            this.search.limit = limit;
            this.list();
        },
        list: function (change_page) {
            this.$base.list(this, change_page);
        },
        exportExcel: function(){
            // this.$base.exportExcel(this);
            excel.exportExcel(this);
        },
        openAdd:function () {
            this.$base.linkTo("/charge/mobilebat/save");
        },
    },
    watch:{
        //界面重新加载数据
        relist:function (newVal,oldVal) {
            if(newVal){
                this.list(true);
                this.relist = false;
            }
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/charge/mobilebat/list.vue